module.exports = __webpack_public_path__ + "img/instagram.5d1e4b97.svg";